<template>
  <div class="wrap">
    <div class="header-left">
      <!-- <div class='float:left;'> -->
      <el-image
        class="imgLogo"
        :src="require('@/assets/image/logo.png')"
        @click="jumpIndex()"
      ></el-image>
<!--      <el-image-->
<!--        class="address_pic"-->
<!--        :src="require('@/assets/image/address.png')"-->
<!--      ></el-image>-->
      <div class="address_text">
        <template>

        </template>
      </div>
      <!-- </div> -->
    </div>
    <!-- 未登录 -->
    <div class="header-right" v-if="userInfo.username == ''">
      <div class="login" @click="login()">登录</div>

      <div class="registered" @click="registered()">
        <el-button type="warning" round>注册</el-button>
      </div>
    </div>
    <!-- 已登陆 -->
    <div class="header-right-line" v-else>
      <el-avatar size="medium" :src="userInfo.avatar"></el-avatar>
      <el-dropdown>
        <span class="el-dropdown-link">
          {{ userInfo.username
          }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-if="userInfo.role == 3"
            @click.native="myCenter(1)"
            >个人中心</el-dropdown-item
          >
          <el-dropdown-item v-if="userInfo.role != 3" @click.native="management"
            >后台管理</el-dropdown-item
          >
          <el-dropdown-item @click.native="logout">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: "header",
  data() {
    return {
      userInfo: {
        id: "",
        username: "",
        avatar: "",
        roles: "",
      },
      username: "",
    };
  },
  created() {
      const userInfo = localStorage.getItem("userInfo");
    if (userInfo != null) {
      this.userInfo = JSON.parse(userInfo);
    }
  },
  watch(){

  },
  methods: {
    // selectMenu(item) {
    //   this.$store.commit("addTab", item);
    // },
    registered() {
      this.$router.push("/registered");
    },
    login() {
      this.$router.push("/webLogin");
    },
    changeArea(value){
        sessionStorage.setItem('area',value)
      this.value = value
    },
    jumpIndex() {
      this.$router.push("/");
    },
    myCenter(res) {
      this.$router.push({
        path: "/myCenter",
        name: "myCenter",
        query: {
          type: res,
          activeName: "first",
        },
      });
    },
    logout() {
      this.$axios.post("/logout").then((res) => {
        localStorage.clear();
        sessionStorage.clear();
        this.$store.commit("resetState");
        this.$router.go(0);
      });
    },
    management() {
      this.$router.push("/Home");
    },
  },
};
</script>

<style scoped>
.imgLogo {
  width: 14.1875rem /* 227px -> 14.1875rem */;
  height: 3.625rem /* 58px -> 3.625rem */;
  vertical-align: middle;
}
.address_pic {
  width: 1.25rem /* 20px -> 1.25rem */;
  height: 1.1875rem /* 19px -> 1.1875rem */;
  vertical-align: middle;
  margin-left: 0.625rem /* 10px -> .625rem */;
}
.address_text {
  float: right;
  width: 10rem;
  margin-left: 0.625rem /* 10px -> .625rem */;
}
.wrap {
  height: 5rem;
  width: 100%;
}
.header-left {
  float: left;
  width: 30rem;
  height: 100%;
  margin-left: 15.625rem;
  color: #000;
}
.address {
  float: left;
}
.header-right-line {
  float: right;
  color: #000;
  width: 9.375rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-right: 13.75rem /* 220px -> 13.75rem */;
}
.header-right {
  float: right;
  color: #000;
  width: 10rem /* 160px -> 10rem */;
  margin-right: 13.75rem /* 220px -> 13.75rem */;
}
.login {
  float: left;
  width: 5rem /* 80px -> 5rem */;
  line-height: 5rem /* 115px -> 7.1875rem */;
  height: 5rem /* 115px -> 7.1875rem */;
  cursor: pointer;
}
.login:hover {
  height: 5rem /* 112px -> 7rem */;
  border-bottom: 3px solid #e6a23c;
}
.registered {
  float: left;
  width: 5rem /* 80px -> 5rem */;
  line-height: 5rem /* 115px -> 7.1875rem */;
  height: 5rem /* 115px -> 7.1875rem */;
  cursor: pointer;
}
.registered:hover {
  height: 5rem /* 112px -> 7rem */;
  border-bottom: 3px solid #f77f00;
}
.el-main {
  color: #333;
  padding: 0;
  width: 100%;
}
</style>
